<template>
  <div class="border-1px">
    <div class="update-adaptive-game-creationBar">
      <div class="row">
        <div class="col-md-12 col-lg-12">
          <adaptive-game-parent-mcq-dropdown v-for="(currMcqObj,index) in getMcqList" :key="currMcqObj.ElementId" :overallList="getOverallList" @currParentMcqObj="updateCurrParentMcqObj" :currComponentIndex="index" :activeRowCountIndex="getCurrentActivatedRowIndexValue" :gameLevelObj="getGameLevelObj"></adaptive-game-parent-mcq-dropdown>
          <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { elementService } from '@/server-util/element-service'
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import AddMcqAdaptiveGame from '@/components/adaptive_game/Update-element/UpdateAddMcqAdaptiveGame'
import AddVideosAdaptiveGame from '@/components/adaptive_game/Update-element/UpdateAddVideosAdaptiveGame'
import AddPostElementsAdaptiveGame from '@/components/adaptive_game/Update-element/UpdateAddPostElementsAdaptiveGame'
import AdaptiveGameParentMCQDropdown from '@/components/adaptive_game/Update-element/UpdateAdaptiveGameParentMCQDropdown'
export default {
  props: ['overallList', 'adaptiveGameResp'],
  created: function () {
    this.setAdaptiveGameElementId()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      currActivatedRowIndex: 0,
      finalObj: {
        'ElementId': '',
        'GameLevels': []
      }
    }
  },
  name: 'update-adaptive-game-creationBar',
  methods: {
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateCurrParentMcqObj (value) {
      var currLevelObj = value.levelObject
      var currSelectedOperation = value.selectedOperation
      this.finalObj.GameLevels.push(currLevelObj)
      this.$emit('finalObjToPost', this.finalObj)
      // TODO: REMOVE BELOW LINE
      // this.finalObj.GameLevels = []
      console.log('this.finalObj.GameLevels >>> ' + JSON.stringify(this.finalObj))
      if (currSelectedOperation === 'create') {
        this.createAdaptiveGame()
      } else {
        this.currActivatedRowIndex = parseInt(value.currComponentIndex) + 1
        console.log('Add operation performed')
      }
    },
    setAdaptiveGameElementId: function () {
      this.finalObj.ElementId = this.getAdaptiveGameServerResponse.ElementId
    },
    createAdaptiveGame: function () {
      var _this = this
      var storeObj = this.$store
      if (this.finalObj !== undefined) {
        // AK: Start showing spinner
        _this.$store.state.isLoading = true
        elementService
          .associateAdaptiveGameElements(storeObj.state.access_token, _this.finalObj)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // console.log(JSON.stringify(responseObj.data))
              _this.$store.state.isLoading = false
              _this.finalObj = {
                'ElementId': '',
                'GameLevels': []
              }
              _this.$emit('finalObjToPost', this.finalObj)
              _this.$emit('currGamePath', responseObj.data)
            } else {
              // AK: Hide Spinner
              _this.$emit('showSpinner', false)
              _this.showAlertDialog = true
              _this.$store.state.isLoading = false
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // AK: Hide Spinner
            _this.$emit('showSpinner', false)
            _this.showAlertDialog = true
            _this.$store.state.isLoading = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Selected finalObj is NULL hence declined ASSOCIATE AG PATH OPERATION'
        )
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'add-mcq-adaptive-game': AddMcqAdaptiveGame,
    'add-videos-adaptive-game': AddVideosAdaptiveGame,
    'add-post-elements-adaptive-game': AddPostElementsAdaptiveGame,
    'adaptive-game-parent-mcq-dropdown': AdaptiveGameParentMCQDropdown
  },
  computed: {
    getGameLevelObj: {
      get: function () {
        return this.finalObj.GameLevels
      }
    },
    getCurrentActivatedRowIndexValue: {
      get: function () {
        return this.currActivatedRowIndex
      }
    },
    getOverallList: {
      get: function () {
        this.currActivatedRowIndex = 0
        return this.overallList
      }
    },
    getAdaptiveGameServerResponse: {
      get: function () {
        return this.adaptiveGameResp
      }
    },
    getMcqList: {
      get: function () {
        return this.overallList.currentMcqList
      }
    }
  }
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.margin-bottom-2Perc {
    margin-bottom: 2%;
}
.font-size-14px {
    font-size: 14px;
}
.padding-right-6px {
    padding-right:6px; 
}
.padding-top-1Perc {
    padding-top:1%;
}
.padding-left-0px {
    padding-left:0px;
}
.padding-right-3em {
    padding-right:3em;
}
.font-size-17px {
  font-size:17px;
}
.border-1px {
  border-right: 1px solid #aaa;
  /* border-bottom: 1px solid #aaa; */
  border-left: 1px solid #aaa;
  border-top: 0px solid #aaa;
}
.padding-top-15px {
  padding-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/adaptive_game/Update-element/UpdateAdaptiveGameCreationBar.vue